/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_Orientation_NumberInputs */

const cs_addr_field_orientation_number = /** @type {(inputs: Addr_Field_Orientation_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo orientační`)
};

const en_addr_field_orientation_number = /** @type {(inputs: Addr_Field_Orientation_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientation number`)
};

/**
* | output |
* | --- |
* | "Orientation number" |
*
* @param {Addr_Field_Orientation_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_orientation_number = /** @type {((inputs?: Addr_Field_Orientation_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_Orientation_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_orientation_number(inputs)
	return cs_addr_field_orientation_number(inputs)
});